import validation from '@/mixins/validation'
import { mapActions, mapGetters } from 'vuex'
import { snakeCase } from 'lodash'

export default {
  name: 'setting-course-categories-translations-item',
  props: {
    locale: {}
  },
  mixin: [validation],
  data () {
    return {
      valid: false,
      payload: {
        locale: this.locale,
        title: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      countryItem: 'settingCountries/currentItem',
      isTranslationLoading: 'settingCountries/isTranslationLoading'
    }),
    currentItem () {
      return this.countryItem.translations.data.find(e => e.locale === this.locale)
    }
  },
  created () {
    if (this.currentItem) {
      Object.assign(this.payload, this.currentItem)
    }
  },
  methods: {
    ...mapActions({
      update: 'settingCountries/UPDATE_TRANSLATION'
    }),
    createRequestPayload () {
      const formData = new FormData()

      for (const i in this.payload) {
        formData.append(snakeCase(i), this.payload[i] || '')
      }
      if (this.currentItem && this.currentItem.hasOwnProperty('id')) {
        formData.append('_method', 'patch')
        // formData.append('id', this.currentItem.id)
      }
      // formData.append('country_id', this.countryItem.id)
      return formData
    },
    submit () {
      this.$refs.form.validate()
      if (this.valid) {
        this.update(this.createRequestPayload()).then(() => {
          this.$toasted.success(this.$t('success_updated'))
        })
      }
    }
  }
}
